<template lang="pug">
	.sd-page-footer
		.sd-page-footer-inner
			| {{ $t('login.copy') }}

</template>

<script>
export default {
	name: 'jnx-footer'
}
</script>
